/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function cartComposition(cart) {
    var hasSubscriptionItem = false;
    var hasOneTimeItem = false;

    cart.items.forEach(function(item) {
      if (item.selling_plan_allocation) {
        hasSubscriptionItem = true;
      } else {
        hasOneTimeItem = true;
      }
    });

    return { hasSubscriptionItem: hasSubscriptionItem, hasOneTimeItem: hasOneTimeItem };
  }

  function correctFreeShippingProgress() {
    var blocks = document.querySelectorAll('[data-free-shipping]');
    if (!blocks.length) return;

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var comp = cartComposition(cart);

        // Only override when cart is subscription-only (no one-time items).
        // Any mixed or one-time-only cart is already calculated correctly
        // by the theme's native logic, since it checks the combined total
        // against the $35 threshold — which matches checkout behavior.
        if (!comp.hasSubscriptionItem || comp.hasOneTimeItem) return;

        blocks.forEach(function(block) {
          var progressBar = block.querySelector('[data-progress-bar]');
          var leftToSpend = block.querySelector('[data-left-to-spend]');

          block.classList.add('is-success');
          if (progressBar) progressBar.value = 100;
          if (leftToSpend) leftToSpend.textContent = '';
        });
      })
      .catch(function(err) { console.error('Free shipping check failed:', err); });
  }

  document.addEventListener('DOMContentLoaded', correctFreeShippingProgress);
  document.addEventListener('theme:product:added', correctFreeShippingProgress);
  document.addEventListener('theme:cart:change', function() {
    setTimeout(correctFreeShippingProgress, 0);
  });

  correctFreeShippingProgress();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();